module.exports = __webpack_public_path__ + "static/media/12.cca152a6.jpg";